module.exports = __webpack_public_path__ + "static/media/logo2.31f3de4a.png";